import React from 'react';
import { Formik } from 'formik';
import { schemaSignIn } from '../../../../../utils/validations';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {loginUser} from '../../../../../store/actions/UserAction'

import SignInForm from '../../../../../components/Forms/SignIn'
import * as ROUTES from '../../../../../routes/';


const SignInEmail = (props) => {
  const onSubmit = (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
    props.loginUser(values.email, values.password, props.roleAuth)
      .then((res) => {
        !props.noPush && props.history.push(ROUTES.LAWYERS_CONTACTED)
        /* setState( ...INITIAL_STATE)
        props.history.push('/'); */
        //props.history.push(ROUTES.HOME)
      })
      .catch(error => {
        let errorCode;
        if (error.code) {
          errorCode = error.code
        } else if (error.data.error) {
          errorCode = error.data.error.code
        }
        
        switch (errorCode) {
          case 'auth/user-not-found':
            setFieldError(
              'email',
              'No existe el usuario proporcionado.'
            )
            break;
          case 'auth/wrong-password':
            setFieldError(
              'password',
              'Constraseña incorrecta'
            )
            break;
          case 'auth/invalid-credential':
            setFieldError(
              'email',
              'Constraseña incorrecta'
            )
            break;
          case 'auth/too-many-requests':
            setFieldError(
              'password',
              'Intente en unos minutos se alcanzo el limite de intentos fallidos'
            )
            break;
          case 'auth/invalid-user':
            setFieldError(
              'email',
              'El usuario no es válido'
            )
            break;
          case 'auth/invalid-role':
            setFieldError(
              'email',
              'El usuario no es válido'
            )
            break;
          default:
            break;
        }
      });
    }

    const initialValues = {
      email: '',
      password: ''
    };

    return ( 
      <Formik
        initialValues={initialValues}
        validationSchema={schemaSignIn}
        onSubmit={onSubmit}
        render={props => <SignInForm {...props} />}
      />
    );
  }
 

const mapDispatchToProps = dispatch => ({
  loginUser: (email, password, roleAuth) => dispatch(loginUser(email, password, roleAuth)),
});

const SignInEmailCompress = compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps,
  ),
)(SignInEmail);

export default SignInEmailCompress;